import { render, staticRenderFns } from "./ViewChange.vue?vue&type=template&id=6372aba0&scoped=true"
import script from "./ViewChange.vue?vue&type=script&lang=js"
export * from "./ViewChange.vue?vue&type=script&lang=js"
import style0 from "./ViewChange.vue?vue&type=style&index=0&id=6372aba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6372aba0",
  null
  
)

export default component.exports